import {Component} from '@angular/core';
import { ToastController } from '@ionic/angular';

import {NavService} from 'shared/nav/nav.service';

import {UserProfile, UserRole} from '../../model/model';
import {UserService} from '../../services/user.service';

const DEV_ROLE_TITLE: string = 'APP_ADMIN';

@Component({
  selector: 'profile-page',
  templateUrl: 'profile-page.html',
  styleUrls: ['profile-page.scss'],
})
export class ProfilePage {

  public devOptionsEnabled: boolean = false;

  public devOptionsAllowed: boolean = false;

  public hasContents: boolean = false;

  constructor(
    public navService: NavService,
    private toastController: ToastController,
    private userService: UserService,
  ) {
    this.userService.getUserProfile('full').subscribe(this.onProfileLoaded.bind(this));
  }

  public get newBadgeCount(): number {
    return this.userService.getNewBadgeCount();
  }

  public get newContentCount(): number {
    return this.userService.getNewContentCount();
  }

  public showDevOptions(): void {
    this.navService.push('profile/devoptions');
  }

  public showBadgesPage(): void {
    this.navService.push('badge');
  }

  public showContentsPage(): void {
    this.navService.push('content');
  }

  public showSettingsPage(): void {
    this.navService.push('profile/settings');
  }

  public showPositionPage(): void {
    this.navService.push('onboarding/position', {isFromMenu: true});
  }

  public showAccountPage(): void {
    this.navService.push('profile/account', {isFromMenu: true});
  }

  public showHelpPage(): void {
    this.navService.push('profile/help');
  }

  public async devMode(): Promise<void> {
    if ( this.devOptionsAllowed ) {
      this.userService.setAdminMode(true);
      this.devOptionsEnabled = true;
      const toast: HTMLIonToastElement = await this.toastController.create({
        message: 'TestModus',
        position: 'bottom',
        duration: 2000,
      });
      await toast.present();

    }
  }

  private onProfileLoaded(profile: UserProfile): void {
    const devRole: UserRole = profile.roles.find((role) => {return role.name === DEV_ROLE_TITLE; });
    if (devRole) {
      this.devOptionsAllowed = true;
    }
    this.hasContents = profile.contents && profile.contents.some((userContent) => userContent.state === 0 || userContent.state >= 5);
  }
}
